export default {"src":"/_next/static/media/find-your-home.b2a783e1.svg","height":657,"width":949};